import React from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth.js";
import { useActiveLeague } from "../../hooks/useActiveLeague";

function PersonalMenu({ showPersonal, setShowPersonal }) {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const { activeLeague } = useActiveLeague();
    const slugPrefix = activeLeague?.slug ? `/${activeLeague.slug}` : '';
    const personal = React.useRef(null);

    React.useEffect(() => {
        // close dropdown if click outside
        function close(e) {
            if (!personal.current.contains(e.target)) {
                setShowPersonal(false);
            }
        }
        // add or remove event listener only when menu is open
        if (showPersonal && setShowPersonal) {
            window.addEventListener("click", close);
        }
        // cleanup
        return function removeListener() {
            window.removeEventListener("click", close);
        }
    }, [showPersonal, setShowPersonal]);

    const handleLogout = async (e) => {
        e.preventDefault();
        if (window.confirm('Are you sure you want to log out?')) {
            try {
                await logout();
            } finally {
                // Close the dropdown and redirect to login regardless of sign-out result
                setShowPersonal(false);
                navigate('/login', { replace: true });
            }
        }
    };

    return (
        <ul ref={personal} className={`profile-nav ${showPersonal ? 'active' : ''}`}>
            {/*<li>*/}
            {/*    <Link to="#">Dashboard</Link>*/}
            {/*</li>*/}
            <li>
                <Link to={`${slugPrefix}/settings-personal`}>Settings</Link>
            </li>
            <li>
                <Link to="#" onClick={handleLogout}>Log out</Link>
            </li>
        </ul>
    );
}

PersonalMenu.propTypes = {
    showPersonal: PropTypes.bool.isRequired,
    setShowPersonal: PropTypes.func.isRequired
};

export { PersonalMenu };